export const PAYMENT_METHOD = {
  CREDIT_CARD: 'CreditCard',
  WIRE_TRANSFER: 'WireTransfer',
} as const
